import React from 'react';

// Unfold Sales Logo Component
const UnfoldSalesLogo = ({ className = "", size = "medium", variant = "light" }) => {
  const sizeClasses = {
    small: "w-8 h-8",
    medium: "w-12 h-12", 
    large: "w-16 h-16",
    xlarge: "w-32 h-32",
    xxlarge: "w-40 h-40"
  };

  // On light/white backgrounds, show logo inside a dark pill so white elements are visible
  if (variant === "dark") {
    return (
      <div className={`${className} relative inline-flex items-center justify-center`}>
        <div className="bg-gradient-to-br from-[#0E0F17] to-gray-800 rounded-2xl px-6 py-3 shadow-md">
          <div className={sizeClasses[size]}>
            <img
              src="https://i.ibb.co/M4LfJvN/Logo-inkl-Schriftzug-removebg-preview.png"
              alt="Unfold Sales Logo"
              className="w-full h-full object-contain"
              onError={(e) => { console.error('Logo failed to load'); }}
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`${sizeClasses[size]} ${className} relative`}>
      <img
        src="https://i.ibb.co/M4LfJvN/Logo-inkl-Schriftzug-removebg-preview.png"
        alt="Unfold Sales Logo"
        className="w-full h-full object-contain"
        onError={(e) => { console.error('Logo failed to load'); }}
      />
    </div>
  );
};

export default UnfoldSalesLogo;
